require('./sass/style.scss')
import $ from 'jquery'
import { gsap } from 'gsap'
import MobileMenu from '~/components/MobileMenu.vue'
import Hamburger from '~/components/Hamburger.vue'
import BoardMeetings from '~/components/BoardMeetings.vue'
import Programs from '~/components/Programs.vue'
import KidsDataCenter from '~/components/KidsDataCenter.vue'
import DualSection from '~/components/DualSection.vue'
import PartnerSlider from '~/components/PartnerSlider.vue'
import ResourcesSlider from '~/components/ResourcesSlider.vue'
import BasicContent from '~/components/BasicContent.vue'
import ShowButtonAboveStats from '~/components/ShowButtonAboveStats.vue'
import Buttons from '~/components/Buttons.vue'
import Stats from '~/components/Stats.vue'
import BigIconsSection from '~/components/BigIconsSection.vue'
import Solicitations from '~/components/Solicitations.vue'
import PublicEvents from '~/components/PublicEvents.vue'

import { createApp } from 'vue'

createApp({
  data() {
    return {
      mobileNav: {
        open: false,
      },
    }
  },
  components: {
    Hamburger,
    'mobile-menu': MobileMenu,
    Buttons,
  },
}).mount('#header')

createApp({
  components: {
    Buttons,
    BasicContent,
    ShowButtonAboveStats,
    BoardMeetings,
    Programs,
    KidsDataCenter,
    DualSection,
    PartnerSlider,
    ResourcesSlider,
    Stats,
    BigIconsSection,
    Solicitations,
    PublicEvents,
  },
}).mount('#flex-app')

$('a[target="_blank"]').append(
  '<svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="external-link" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" class="tw-w-4 ml-2 external-link"><path fill="currentColor" d="M195.515 374.828c-4.686-4.686-4.686-12.284 0-16.971l323.15-323.15-.707-.707-89.958.342c-6.627 0-12-5.373-12-12v-9.999c0-6.628 5.372-12 12-12L564 0c6.627 0 12 5.372 12 12l-.343 136c0 6.627-5.373 12-12 12h-9.999c-6.627 0-12-5.373-12-12L542 58.042l-.707-.707-323.15 323.15c-4.686 4.686-12.284 4.686-16.971 0l-5.657-5.657zm232-155.633l-8 8A12 12 0 0 0 416 235.68V464c0 8.837-7.164 16-16 16H48c-8.836 0-16-7.163-16-16V112c0-8.837 7.164-16 16-16h339.976c3.183 0 6.235-1.264 8.485-3.515l8-8c7.56-7.56 2.206-20.485-8.485-20.485H48C21.49 64 0 85.49 0 112v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V227.681c0-10.691-12.926-16.045-20.485-8.486z" class=""></path></svg>',
)

jQuery(document).ready(function ($) {
  // Team Page: Check the Department Selection Box when Filtered
  var $categoryTitles = $('.category-option .single-category-option')
  $categoryTitles.click(function () {
    $(this).siblings().removeClass('checked')
    $(this).addClass('checked')
  })

  // Video lightbox open / autoplay (nothing to do with document or default lightbox)
  window.onhashchange = function () {
    setTimeout(function () {
      var lightboxes = $('.lightbox')
      $(lightboxes).each(function (index) {
        if ($(this).css('display') != 'none') {
          var iframe = $(this).find('iframe')
          var videoSrc = $(iframe).attr('src')
          $(iframe).attr('src', videoSrc + '?autoplay=1')
        } else {
          var iframe = $(this).find('iframe')
          var videoSrc = $(iframe).attr('src')
          if (typeof videoSrc != 'undefined') {
            var newSrc = videoSrc.replace('?autoplay=1', '')
            $(iframe).attr('src', newSrc)
          }
        }
      })
    }, 200)
  }
})

//Header ADA compliance Tool tip
// Check if elements with class "tip" exist before calling TweenLite.set
if (document.querySelector('.tip')) {
  gsap.set('.tip', { display: 'none' })
}
$('.ada-box').on('mouseenter', () => {
  gsap.set('.tip', { display: 'block' })
  gsap.to('.tip', {
    duration: 0.35,
    opacity: 1,
    top: 0,
  })
})
$('.ada-header').on('mouseleave', function () {
  gsap.to('.tip', {
    duration: 0.35,
    opacity: 0,
    top: '100px',
    onComplete: () => {
      gsap.set('.tip', { display: 'none' })
    },
  })
})

//ADA Compliance overrides
$('.site-controls select').attr('aria-label', 'Google Translate Options')
$('.google-translate select').attr('aria-label', 'Google Translate Options')
